/**
 * StakeOfferScreen.tsx
 * New stake offer screen
 */

import { type FC } from 'react';

import { Button } from '@skillarea/lib-frontend';
import { Title } from '@skillarea/lib-frontend';
import { formatMoney } from '@skillarea/lib-shared';
import { useTranslation } from 'react-i18next';

import styles from '../MatchmakingModal.module.scss';

export interface IStakeOfferScreenProps {
  suggestedStake: number;
  reason: string;
  onAccept: () => void;
  onDecline: () => void;
}

export const StakeOfferScreen: FC<IStakeOfferScreenProps> = ({
  onAccept,
  onDecline,
  suggestedStake,
}) => {
  const { t } = useTranslation('matchmaking');

  return (
    <div className={styles.screen}>
      <div className={`${styles.centered} ${styles.resultScreen}`}>
        <Title
          className={styles.resultTitle}
          color="contrast"
          size="l"
          variant="benzin"
        >
          {t('stake.updatedEntryFee')}
        </Title>

        <Title color="accent" size="l">
          {formatMoney(suggestedStake)}
        </Title>
      </div>

      <div className={styles.footer}>
        <div className={styles.actionButtons}>
          <Button
            className={styles.acceptButton}
            color="accent"
            name={t('common.accept')}
            onClick={onAccept}
            size="s"
            variant="filled"
          >
            {t('common.accept')}
          </Button>
          <Button
            className={styles.declineButton}
            color="primary"
            name={t('common.decline')}
            onClick={onDecline}
            size="s"
            variant="filled"
          >
            {t('common.decline')}
          </Button>
        </div>
      </div>
    </div>
  );
};
